import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledIndicatorCustom, StyledIndicatorStatus, StyledIndicatorWrapper } from './styled';
import { AvatarIndicatorStatus, AvatarIndicatorVariant } from './types';
export function AvatarIndicator({ size = 'm', variant = AvatarIndicatorVariant.status, status = AvatarIndicatorStatus.offline, icon, ...rest }) {
    return /*#__PURE__*/ _jsxs(StyledIndicatorWrapper, {
        $size: size,
        $status: status,
        $variant: variant,
        $icon: !!icon,
        children: [
            variant === AvatarIndicatorVariant.status && /*#__PURE__*/ _jsx(StyledIndicatorStatus, {}),
            variant === AvatarIndicatorVariant.custom && icon && /*#__PURE__*/ _jsx(StyledIndicatorCustom, {
                children: icon
            })
        ]
    });
}
